/**
 * [INPUT]: 依赖 Brand、ThemeSwitcher、React Router 导航与子页面
 * [OUTPUT]: 对外提供 AppShell 响应式页面框架
 * [POS]: components 的全局 chrome，只承载书库与离线书架两个真实产品入口
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { Archive, Library } from 'lucide-react'
import type { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

import { Brand } from './Brand'
import { ThemeSwitcher } from './ThemeSwitcher'

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        跳到正文
      </a>
      <header className="app-header">
        <Brand />
        <nav className="main-nav" aria-label="主导航">
          <NavLink to="/" end>
            <Library size={17} aria-hidden="true" />
            书库
          </NavLink>
          <NavLink to="/offline">
            <Archive size={17} aria-hidden="true" />
            离线
          </NavLink>
        </nav>
        <ThemeSwitcher />
      </header>
      <main id="main-content" tabIndex={-1}>
        {children}
      </main>
      <footer className="app-footer">Morrow · 由内容 Agent 整理，公开只读</footer>
    </div>
  )
}
